import { Drawer } from 'antd';

/**
 * AppDrawer Component
 *
 * A reusable wrapper around Ant Design's Drawer component with sensible defaults.
 * Provides a simple way to display side panels for content such as forms, menus, or details.
 *
 * @component
 *
 * @param {Object} props - Component props
 * @param {boolean} props.visible - Controls whether the drawer is visible.
 * @param {function} props.onClose - Callback fired when the drawer is closed.
 * @param {string} [props.title='Drawer'] - Title displayed at the top of the drawer.
 * @param {number|string} [props.width=400] - Width of the drawer (number for pixels, or string for percentage/other CSS units).
 * @param {React.ReactNode} [props.footer] - Optional footer content (e.g., buttons).
 * @param {'left' | 'right' | 'top' | 'bottom'} [props.placement='right'] - The position of the drawer.
 * @param {React.ReactNode} props.children - The content to render inside the drawer.
 * @param {string} [props.className=''] - Additional CSS class names for custom styling.
 *
 * @example
 * <AppDrawer
 *   visible={isDrawerOpen}
 *   onClose={() => setDrawerOpen(false)}
 *   title="User Details"
 *   width={500}
 *   footer={<Button onClick={saveChanges}>Save</Button>}
 * >
 *   <UserForm />
 * </AppDrawer>
 */

export default function AppDrawer({ visible, onClose, title = 'Drawer', width = 400, footer, placement = 'right',maskClosable, children, className = '' }) {
    return (
        <Drawer title={title} placement={placement} onClose={onClose} open={visible} width={width} footer={footer} maskClosable={maskClosable} className={className}>
            {children}
        </Drawer>
    );
}
